import React from "react";
import collage from "./../assets/collage.jpg";

const contactItems = [
  {
    label: "Correo electrónico",
    value: "Bczamora96@gmail.com",
    href: "mailto:Bczamora96@gmail.com",
    iconBg: "bg-primary-lighter group-hover:bg-primary",
    iconColor: "text-primary group-hover:text-white",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: "WhatsApp",
    value: "+56 9 6608 8903",
    href: "https://api.whatsapp.com/send?phone=56966088903&text=",
    target: "_blank",
    iconBg: "bg-mint-lighter group-hover:bg-mint",
    iconColor: "text-mint group-hover:text-white",
    icon: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    label: "Terapia Ocupacional",
    value: "Centro Volantín",
    href: "https://encuadrado.com/p/barbara-zamora/",
    target: "_blank",
    iconBg: "bg-primary-lighter group-hover:bg-primary",
    iconColor: "text-primary group-hover:text-white",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    label: "Clases de Natación",
    value: "A domicilio y Piscina Municipal Vitacura",
    href: "https://api.whatsapp.com/send?phone=56966088903&text=Hola, me gustaría tomar clases de natación",
    target: "_blank",
    iconBg: "bg-ocean-lighter group-hover:bg-ocean",
    iconColor: "text-ocean group-hover:text-white",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
];

const ContactoForm = () => {
  return (
    <section className="bg-primary-lighter overflow-hidden" id="contacto">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-white text-primary font-body font-semibold text-sm px-4 py-1.5 rounded-full mb-3 shadow-soft">
            Hablemos
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">
            Contacto
          </h2>
          <p className="mt-3 text-gray-500 font-body text-base max-w-lg mx-auto">
            ¿Tienes preguntas? Estoy aquí para ayudarte
          </p>
        </div>

        {/* Image card */}
        <div className="relative rounded-4xl overflow-hidden shadow-soft-lg mb-10 h-72 sm:h-96">
          <img
            src={collage}
            alt="Barbara Zamora - Terapeuta Ocupacional"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/70 via-indigo-900/20 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4">
            <div>
              <p className="font-heading text-white text-2xl font-semibold drop-shadow">Barbara Cecilia Zamora Tapia</p>
              <div className="flex flex-wrap gap-2 mt-2">
                <span className="inline-flex items-center gap-1.5 bg-primary/80 backdrop-blur-sm text-white font-body text-xs font-semibold px-3 py-1 rounded-full">
                  Terapeuta Ocupacional
                </span>
                <span className="inline-flex items-center gap-1.5 bg-ocean/80 backdrop-blur-sm text-white font-body text-xs font-semibold px-3 py-1 rounded-full">
                  Profesora de Natación
                </span>
              </div>
            </div>
            <a
              href="https://api.whatsapp.com/send?phone=56966088903&text="
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 inline-flex items-center gap-2 bg-warm hover:bg-orange-500 text-white font-body font-bold px-5 py-3 rounded-2xl shadow-soft transition-all duration-200 hover:scale-105 cursor-pointer text-sm"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Escribir por WhatsApp
            </a>
          </div>
        </div>

        {/* Contact cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {contactItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              target={item.target}
              rel={item.target ? "noopener noreferrer" : undefined}
              className="group flex items-center gap-4 bg-white rounded-2xl p-5 shadow-soft hover:shadow-soft-lg hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0 transition-colors duration-200 ${item.iconBg}`}>
                <span className={`transition-colors duration-200 ${item.iconColor}`}>
                  {item.icon}
                </span>
              </div>
              <div className="min-w-0">
                <p className="text-xs text-gray-400 font-body font-medium mb-0.5">{item.label}</p>
                <p className="text-base font-heading font-semibold text-gray-800 truncate">{item.value}</p>
              </div>
              <svg className="w-5 h-5 text-gray-300 group-hover:text-primary ml-auto flex-shrink-0 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          ))}
        </div>
      </div>

      {/* Wave */}
      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,0 C360,60 1080,0 1440,40 L1440,60 L0,60 Z" fill="#1e1b4b" />
        </svg>
      </div>
    </section>
  );
};

export default ContactoForm;
